/* global espn */
import qs               from 'query-string'
import { memoizr }      from '../../../reduxion-core/lib'
import actionTypes      from '../../constants/actionTypes'
import * as transform   from '../../lib/transform'
import * as cricket     from './cricket'
import config           from '../../../config'
import selectn          from 'selectn'
import getStandingsPage from './standings'
import getSchedule      from './schedule'
import getClubhouse     from './clubhouse'
import { getCountrySupportedRegion } from '../../lib/utils/common'
import moment from 'moment-timezone'

/**
 * Gets the API host based on the environment
 * @param  {String} service   type of service (site, v1, score)
 * @param  {String} platform  type of platform (android, ios)
 * @param  {Object} appProps  tyoe of app, which api being used
 * @return {String}           API host
 */
export function getHost( service = 'site', platform = '', appProps={} ) {
  service = service.toLowerCase()
  if(service == 'site' && appProps.qaApi) {
    service = 'site_qa'
  }
  if(service == 'score' && appProps.qaApi) {
    service = 'sCoreQahost'
  }
  platform = platform || process.browser ? 'client' : 'server'
  const hostMap = {
    site: {
      client: 'client',
      server: 'server'
    },
    site_qa: {
      client: 'client_qa',
      server: 'server_qa'
    },
    v1: {
      client: 'client_v1',
      server: 'server_v1'
    },
    score: {
      client: 'sCoreTcClient',
      server: 'sCoreTcServer'
    },
    now:{
      client: 'now_client',
      server: 'now_server'
    },
    sCoreQahost: {
      client: 'sCoreQahost'
    }
  }

  const hostConfig = hostMap[service]
  const key = hostConfig[platform]
  const apiHost = config.apiHost
  let finalHost = apiHost[key]

  if(platform === 'client') {
    finalHost = typeof window !== 'undefined' && selectn(`espn.reduxion.apiHost[${key}]`, window) || finalHost
  }

  //return 'http://' +'10.42.45.211:9003'
  return 'https://' + finalHost
}

/**
 * get query string from Object
 * @param  {Object}  queryObject        query object
 * @param  {Object}  edition            edition config
 * @param  {Object}  params             router params
 * @param  {Boolean} skipEditionParams  flag to skip edition params
 * @param  {Boolean} skipSectionParams  flag to section params if API does not require section=cricinfo
 * @return {String}                     full query string starting with `?`
 */
export function getQueryString(queryObject = {}, edition = {}, params = {}, skipEditionParams = false, skipSectionParams = false) {
  let { userGeo, language, country, domain } = edition
  let isSonyESPN = (domain === "www.espn.in")
  country = isSonyESPN ? getCountrySupportedRegion(userGeo) : country

  if ( !skipEditionParams) {
    queryObject.region = country
    queryObject.lang = language
  }

  // All Espncricinfo API's calls have additionl param 'section=cricinfo'.
  if ( edition.isEspnCricinfo && !skipSectionParams) {
    queryObject.section = 'cricinfo'
  }
  const queryString = qs.stringify( queryObject )

  return queryString ? '?' + queryString : ''
}

/**
 * Creates and returns an API action
 * @param  {Function} fn    Action
 * @param  {Object} params  Args to call the function with
 * @return {Function}       API action
 */
export function createAction(fn, params) {
  return function (routingParams, ...rest) {
    return fn.call(null, Object.assign({}, params, routingParams), ...rest)
  }
}

/**
 * action to get leagues
 * @param  {Object} edition   edition config
 * @param  {Object} params    router params
 * @param  {Object} location  Router location
 * @return {Object}           action
 */
export function getLeagues({ edition = {}, params = {}, location = {}, appProps }) {
  let queryObject = {}
  if(params.sport == 'cricket' && params.pageType=='scores') {
    return {
      type : null
    }
  }
  let actionObject = {
    type: actionTypes.GET_LEAGUES,
    sport: params.sport,
    pageType: params.pageType,
    edition: edition
  }
  // Return if team scoreboard, does not require leagues (only cricket)
  if(typeof params.team !== 'undefined' && params.sport === 'cricket') {
    return actionObject
  }

  if(params.sport === 'cricket') {
    queryObject.ceId = 15031083
  }else{
    queryObject.sport = params.sport
  }

  const url = `${params.origin || getHost('site', '', appProps)}/apis/site/v2/leagues/dropdown${getQueryString(queryObject, edition, params)}`

  actionObject.url = url
  actionObject.edition = edition
  actionObject.params = params
  actionObject.location = location
  actionObject.promise = memoizr.get(url, { cachePolicy: 'max-age=30' })
  actionObject.transform = transform.onGetLeagues

  return actionObject
}

/**
 * action to get scoreboard
 * @param  {Object} edition     edition config
 * @param  {Object} params      router params
 * @param  {Object} location    Router location
 * @param  {Boolean} isPolling  isPolling
 * @return {Object}             action
 */
export function getScoreboard({ edition = {}, params = {}, location = {}, isPolling, appProps }) {
  const query = location.query || qs.parse(location.search)
  let { topEventsId, language } = edition
  let league = params.league
  let date = query.date || params.date


  let queryObject = {
    dates: date,
    contentorigin: (language === 'es' || language === 'pt') ? 'deportes' : 'espn'
  }

  const curDate = moment.utc().format('YYYYMMDD')

  if (!params.sport) {
    return {
      type: null
    }
  }

  // Add default dates to api querystring only for team SB, for aggregate SB date need not be passed
  if ( typeof params.team !== 'undefined' ) {
    queryObject.team = params.team
    if(typeof date === 'undefined') {
      queryObject.dates = moment().format('YYYYMM')
      if(params.sport === 'rugby') {
        queryObject.dates = moment().format('YYYY')
      }
      if(typeof params.season !== 'undefined') {
        queryObject.dates = params.season
      }
    }
    if(typeof limit === 'undefined') {
      queryObject.limit = 50
    }
    if( params.sport === 'rugby' ) {
      //params.origin = 'https://site.web.api.espnqa.com'
      league = undefined /* if we have a team no need to filter by league */
    }
  }
  if(!params.league && !params.team && params.sport == 'cricket') {
    if(typeof queryObject.dates === 'undefined' || (queryObject.dates === curDate)) {
      queryObject.ceID = topEventsId
    }
  }

  if (params.sport == 'cricket' && (params.league || params.team)) {
    queryObject.section = 'cricinfo'
  }
  let host = getHost('site', '', appProps)
  let url = `${params.origin || host}/apis/site/v2/sports/${params.sport}/scorepanel${getQueryString(queryObject, edition, params)}`

  if ( league ) {
    queryObject.limit = 300
    queryObject.sort = 'events:asc'
    if(params.season) {
      queryObject.season = params.season
    }
    url = `${params.origin || host}/apis/site/v2/sports/${params.sport}/${league}/scoreboard${getQueryString(queryObject, edition, params)}`
  }

  return {
    url,
    edition,
    location,
    params,
    appProps,
    isPolling: isPolling,
    type: actionTypes.GET_SCOREBOARD,
    sport: params.sport,
    promise: memoizr.get(url),
    transform: transform.onGetScoreboard
  }
}
export function updateFavorites(sport = 'cricket') {
  return (dispatch) => {
    try {
      espn.user.getFavorites().then((res={})=>{
        let favTeams = []
        if(typeof res !== 'undefined') {
          (res.myTeams || []).map((key = {}) => {
            if(typeof key.sportName == 'string' && key.sportName.toLowerCase() === sport) {
              favTeams.push(key.id)
            }
          })
        }
        dispatch({
          type : actionTypes.UPDATE_FAVORITES,
          data : favTeams
        })
      })
    } catch(e) { console.log(e) }
  }
}
export function getTopEventScores({ edition = {}, params = {}, location = {}, isPolling, appProps }) {
  const query = location.query || qs.parse(location.search)
  let { topEventsId } = edition
  const date = query.date || params.date
  const curDate = moment.utc().format('YYYYMMDD')
  let showTopEvents = false
  if(params.sport === 'cricket' && !params.league && !params.team) {
    if(typeof date === 'undefined' || date === curDate) {
      showTopEvents = true
    }
  }

  if(!showTopEvents) {
    return {
      type: null
    }
  }

  let queryObject = {
    contentorigin: 'espn',
    _ceID: topEventsId
  }

  let host = getHost('site', '', appProps)
  let url = `${params.origin || host}/apis/v2/scoreboard/header${getQueryString(queryObject, edition, params)}`

  return {
    url,
    edition,
    location,
    params,
    appProps,
    isPolling: isPolling,
    type: actionTypes.GET_TOPEVENTS,
    sport: params.sport,
    promise: memoizr.get(url),
    transform: transform.onGetTopEventScores
  }
}

/**
 * action to get editorial content for scoreboard
 * @param  {Object} edition   edition config
 * @param  {Object} params    router params
 * @param  {Object} location  Router location
 * @return {Object}           action
 */
export function getEditorial({ edition = {}, params = {}, location = {}, appProps }) {
  let { country, language } = edition
  let queryObject = {
    headlinestack: typeof params.headlinestack === 'boolean' ? params.headlinestack : true,
    insider: params.insider || false,
    pubkey: params.pubkey || `espnuk-en-${params.sport}-index`,
    region: country,
    lang: language,
    limit: 0,
    contentorigin: (language === 'es' || language === 'pt') ? 'deportes' : 'espn'
  }

  if(language === 'es' || language === 'pt') {
    queryObject.pubkey = `espn-${language}-${country}-${params.sport}-index`
  }

  if(params.sport === 'cricket') {
    //pubkey has uk in case of edition country as gb.
    //Also managing pubkeys for espn editions for the countries au, ph
    let cricketPubkey = (edition.site === 'espncricinfo')
      ?`espncricinfo-en-${edition.country==='gb'?'uk':edition.country}-${params.sport}-index`
      :((edition.country === 'gb')
        ?`espncricinfo-en-uk-${params.sport}-index`
        :(edition.country === 'au' || edition.country === 'ph'
          ?`espncricinfo-en-in-${params.sport}-index`
          :`espncricinfo-en-${edition.country}-${params.sport}-index`))

    queryObject.pubkey =  cricketPubkey

    if(country === 'gb') {
      queryObject.region = 'uk'
    }

  }

  let host = getHost('site', '', appProps)
  const url = `${params.origin || host}/apis/v2/flex${getQueryString(queryObject, edition, params, true)}`

  return {
    url,
    edition,
    params,
    location,
    type: actionTypes.GET_EDITORIAL,
    promise: memoizr.get(url, { cachePolicy: 'max-age=300' }),
    transform: transform.onGetEditorial
  }
}

/**
 * Action to get Game package summary
 * @param  {Object}   edition   edition config
 * @param  {Object}   params    Router params
 * @param  {Object}   location  Router location
 * @param  {Boolean}  isPolling isPolling
 * @return {Function}           Handled by thunk middleware
 */
export function getGameSummary({ edition = {}, params = {}, location = {}, isPolling, appProps = {} }) {

  const queryObject = {
    event: params.gameId || 0,
    contentorigin: 'espn'
  }
  const league = params.league || 0

  if (appProps.isAppLite === true) {
    queryObject.device = 'featurephone'
  }

  if(edition.language === 'es' || edition.language == 'pt') {
    queryObject.contentorigin = 'deportes'
  }

  let path = `/apis/site/v2/sports/${params.sport}/${league}/summary${getQueryString(queryObject, edition, params)}`
  let clientApiUrl = ''

  // get client url only once
  if(!process.browser) {
    clientApiUrl = `${getHost('site', 'client', appProps)}${path}`
  }
  let host = getHost('site', '', appProps)
  const url = `${params.origin || host}${path}`

  return {
    url,
    clientApiUrl,
    edition,
    location,
    params,
    isPolling,
    appProps,
    type: actionTypes.GET_GAMEPACKAGE,
    promise: memoizr.get(url),
    transform: transform.onGetGamePackage
  }
}

/**
 * Action to get Game package
 * @param  {Object} edition     edition config
 * @param  {Object} params      Router params
 * @param  {Object} location    Router location
 * @param  {Boolean} isPolling  isPolling
 * @return {Object|Function}    redux action
 */
export function getGamePackage({ edition = {}, params = {}, location = {}, isPolling, appProps = {} }) {
  if(params.sport === 'cricket') {
    if(params.pageType === 'commentary') {
      return (dispatch) => {
        return dispatch(cricket.getCommentaryTab({ edition, params, location, isPolling, appProps }))
      }
    }else if(params.pageType === 'preview' || params.pageType === 'report') {
      return (dispatch) => {
        return dispatch(cricket.getArticleTab({ edition, params, location, isPolling, appProps }))
      }
    }else {
      return getGameSummary({ edition, params, location, isPolling, appProps })
    }
  }else {

    if ( params.pageType === 'preview' || params.pageType === 'report' ) {
      return (dispatch) => {
        return dispatch(cricket.getArticleTab({ edition, params, location, appProps }))
      }
    }

    return getGameSummary({ edition, params, location, isPolling, appProps })

  }
}

export function getGeoLocation(params) {
  return {
    params,
    type: actionTypes.GET_GEO_LOCATION,
    promise: new Promise((resolve) => {
      const getLocation = selectn('espn.geo.getLocation', window || {})
      if(!getLocation) {
        resolve()
      } else {
        getLocation.done(resolve)
      }
    }),
    transform: transform.onGetGeoLocation
  }
}

export function getVideosMore({ edition = {}, params = {}, location, isForceLazyload = false }) {
  return (dispatch, getState) => {
    const allVideos = selectn('gamePackage.allVideos', getState())
    const { currentVideosCount, resultsOffset } = allVideos || {}

    // videos per page
    let limit = 10
    let offset = resultsOffset ? (currentVideosCount + resultsOffset) : 20

    if (isForceLazyload === true) {
      limit = 30
    }

    const queryObject = {
      limit,
      offset
    }
    let host = getHost('v1')
    const url = `${params.origin || host}/v1/video/${params.sport}/${params.sport}/events/${params.gameId}/clips${getQueryString(queryObject, edition, params)}`
    const videoPromise = memoizr.get(url)

    videoPromise.then( (res) => {
      dispatch({
        url,
        edition,
        params,
        location,
        type: actionTypes.GET_VIDEOS_MORE,
        data: transform.onGetVideos({ res })
      })
    })
  }
}

/**
 * action when api call is started
 * used in thunk middleware to dispatch api request action
 * @param  {boolean}  isPolling   Boolean to pass through to determine if this is polling
 * @return {Object}   store       Action
**/
export function apiReqStart( isPolling ) {
  return {
    type: actionTypes.API_REQUEST_START,
    isPolling
  }
}

/**
 * action when api call is completed
 * used in thunk middleware to dispatch api complete action
 * @return {Object} store action
 */
export function apiReqComplete() {
  return {
    type: actionTypes.API_REQUEST_COMPLETE
  }
}

/**
 * [getFlexApiUrl , will return final API url]
 * @param  {Object} edition         [edition details]
 * @param  {Object} params          [page params]
 * @param  {Object} location        [location details]
 * @param  {Object} additionalQuery [additiona queries for the page to load]
 * @param  {Object} appProps        [additional props]
 * @return {[string]}               [final url with required params]
 */
export function getFlexApiUrl(edition = {}, params = {}, location = {}, additionalQuery = {}, appProps) {
  let queryObject = {
    region: params.country || edition.country,
    headlinestack: typeof params.headlinestack === 'boolean' ? params.headlinestack : true,
    insider: params.insider || false,
    lang: params.lang || edition.language,
    pubkey: `espn-en-${params.sport}-index`,
    contentorigin: (edition.language === 'es' || edition.language === 'pt') ? 'deportes' : 'espn'
  }
  let host = getHost('site', '', appProps)
  let url = `${params.origin || host}/apis/v2/flex${getQueryString(Object.assign(queryObject, additionalQuery), edition, params)}`

  return url
}

/**
 * [getNowApiUrl , will return final API url]
 * @param  {Object} edition         [edition details]
 * @param  {Object} params          [page params]
 * @param  {Object} location        [location details]
 * @param  {Object} additionalQuery [additional queries for the page to load]
 * @return {[string]}               [final url with required params]
 */
export function getNowApiUrl(edition = {}, params = {}, location = {}, additionalQuery = {}) {
  let queryObject = {
    region: params.country || edition.country,
    lang: params.lang || edition.language,
    limit: 25
  }
  let host = getHost('now')
  let queryString = getQueryString(Object.assign(queryObject, additionalQuery), edition, params)
  queryString = decodeURIComponent(queryString)

  let url = `${params.origin || host}/allsports/apis/v1/now/${queryString}`

  return url
}


/**
 * [getMoreMidColFeed - will get more items for lazyload]
 * @param  {Object} edition  [edition details]
 * @param  {Object} params   [page params]
 * @param  {Object} location [location details]
 * @return {[type]}          [redux action]
 */
export function getMoreMidColFeed(edition = {}, params = {}, location = {}) {
  return (dispatch, getState) => {
    const midColumn = selectn('clubhouse.middleColumn', getState()) //state before the new API request fired, currently for 'Clubhouse', ToDO, how it can be dynamic
    const { resultsOffset } = midColumn || {}
    let currentArticleCount = selectn('newsfeed.length', midColumn)

    let setOffset = 25 //to fetch new items set the offset
    let offset = resultsOffset + setOffset //increment by setOffset with previous offset for every api call

    // Attributes for now API specific to sports clubhouse
    let clubhouseAttr = {
      'rugby': {
        '_pinnedID' : 14056160,
        'content' : 'alert,shortstop,video,story,blog,module,external,recap,preview,topstorypackage,podcast'
      },
      'cricket' : {
        '_pinnedID' : 15083330,
        'content' : 'alert,shortstop,video,story,blog,module,external,recap,preview,topstorypackage,podcast,grantland,fivethirtyeight'
      },
      'soccer' : {
        '_pinnedID' : 11875394,
        'content' : 'alert,shortstop,video,story,blog,module,external,recap,preview,topstorypackage,podcast,instagram,grantland,fivethirtyeight'
      }
    }

    // Common attributes for now API for Clubhouse
    if(params.pageType === 'team') {
      var additionalQuery = {
        teams: params.team,
        leagues: params.sport,
        offset: offset,
        enable: 'peers,story,logos,headshots',
        defaultsort: 'false',
        logosize: 'large',
        headshotsize: 'full',
        sort: 'false',
        filtertypes: 'OnePlay',
        content: clubhouseAttr[params.sport].content,
        _pinnedID : clubhouseAttr[params.sport]._pinnedID
      }
    }

    let url = getNowApiUrl(edition, params, location, additionalQuery) //now api call for clubhouse page, it accepts offset to get content for clubhouse
    const newsfeedPromise = memoizr.get(url)

    newsfeedPromise.then( (res) => {
      dispatch({
        url,
        edition,
        params,
        location,
        type: actionTypes.GET_MORE_MID_COL_FEED,
        data: transform.getMoreMidColFeed(res, edition, params, currentArticleCount)
      })
    })
  }
}

/**
 * [getLeagueSearch - Method to fetch typeahead search results]
 * @param  {Object} edition         [edition for site details]
 * @param  {Object} params          [params for lang, region]
 * @param  {Object} additionalQuery [additional queries, includes search keyword]
 * @param  {Object} appProps        type of app, which api being used
 * @return {promise}                [returns promise for search]
 */
export function getLeagueSearch(edition = {}, params = {}, additionalQuery = {}, appProps) {

  let { limit, query } = additionalQuery
  let queryObject = {
    section: edition.site,
    region: params.region || edition.region,
    lang: params.lang || edition.language,
    limit: limit || 8,
    query: query,
    mode: 'prefix',
    type: 'league'
  }

  if(espn && espn.i18n && espn.i18n.isSingleSport === false){
    queryObject.type = 'league,sport'
  }

  if(query != '') {
    if(params.sport !== '') {
      queryObject.sport = params.sport
    }

    let keyW = queryObject.query ? queryObject.query.replace(/\s+/g,'+') : ''
    queryObject.query = keyW
    //params set to false/true in getQueryString method: skipEditionParams = false, skipSectionParams = true
    let queryString = getQueryString(queryObject, edition, params, false, true)
    queryString = decodeURIComponent(queryString)

    let host = getHost('site', '', appProps)
    let url = `${params.origin || host}/apis/common/v3/search${queryString}`

    let leagueSearchPromise = memoizr.get(url)

    return leagueSearchPromise
  }

}

export { getSchedule }
export { getStandingsPage }
export { getClubhouse }

export const api = {
  getLeagues,
  getStandingsPage,
  getScoreboard,
  getTopEventScores,
  updateFavorites,
  getGamePackage,
  getGameSummary,
  getSchedule,
  getClubhouse,
  getLeagueSearch,
  getEditorial
}



// WEBPACK FOOTER //
// ../app/actions/api/index.js